function __pynLog(msg) {
  //console.log('📌', msg);
  return true;
}

function __pynAppendForm(id) {
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'items[][id]';
    input.value = id;
    form.appendChild(input);

    form.addEventListener('submit', evt => {
      document.querySelectorAll('input[value="' + id + '"]').forEach(offerInput => {
        offerInput.parentNode.removeChild(offerInput);
      });
    });
  });
}

// Detect scrollbar width to apply padding when drawer flyout
// to avoid content shift when body overflow is set to hidden
(function () {
  var scrollDiv = document.createElement("div");
  scrollDiv.innerText = "Test";
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";
  scrollDiv.style.overflow = "scroll";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.style.setProperty("--scrollbar-width", scrollbarWidth + "px");

  document.body.removeChild(scrollDiv);
})();

// shaker
(function() {
    function loop(callBack) {
        var collection = document.getElementsByClassName('product-form__submit');
        for (let i = 0; i < collection.length; i++) {
            callBack.call(this, collection[i]);
        }
    }
    loop(function(item){
        item.classList.add('__pyn-btn-animate');
    });
    setInterval(function(){
        loop(function(item){
            item.classList.add('__pyn-animate-active');
        });
        setTimeout(function() {
            loop(function(item){
                item.classList.remove('__pyn-animate-active');
            });
        }, 1000);
    }, 5000);
})();

// Auto cart
(function() {
  function addBook(bookSKU, bookId) {
    /* Load current cart info */
    if (window.__pynCartData.items.some(item => item.sku == bookSKU)) {
      __pynLog("Free book is already in cart page");
      return;
    }

    /* Update product form if everything is OK */
    __pynAppendForm(bookId);
  }

  document.addEventListener("DOMContentLoaded", async function () {
    /* Test mode */
    //if (!/test=thuy/.test(document.cookie)) {
    //  return;
    //}
    //__pynLog('Dev on!');

    /* Only apply on pages that have properties */
    if (!window.__pynProductId || !window.__pynCollections || !window.__pynCartData) {
      __pynLog("There is no product or cart info");
      return;
    }

    /* Filter product ids */
    const __excludedCollections = [
      'accessories',
      'gift-cards'
    ];
    
    if (window.__pynCollections.length === 0) {
      __pynLog("Product is not in any collection");
      return;
    }

    for (let collection of window.__pynCollections) {
      if (__excludedCollections.includes(collection)) {
        __pynLog("Product is in excluded list");
        return;
      }
    }

    /* Add diamond free book */
    const __diamondPainting = [
      'diamond-painting',
      'mini-diamond-painting'
    ];

    for (let collection of window.__pynCollections) {
      if (__diamondPainting.includes(collection)) {
        addBook('IntroDP', 47241364209885);
        return;
      }
    }

    /* Add default Intro book */
    addBook('IntroPBN', 43764999258333);

    /* Cart page remove button */
    //document.querySelector('cart-items')?.addEventListener('change', evt => {
    //  __pynLog(evt);
    //});
  });
})();

(function() {
  document.addEventListener("DOMContentLoaded", async function () {
    const __discount_code = 'FREEKIT';
    const __startDate = "2025-03-18T23:53:00-04:00"; // UTC-4 (EDT)
    const __endDate = "2025-04-30T23:53:00-04:00";
    const __excludedCollections = [
      'diamond-painting',
      'mini-diamond-painting',
      'accessories',
      'gift-cards'
    ];
    const __freeProducts = [
      "no-stain-glove",
      "apron"
    ];
    
    function isWithinDateRange() {
      const startDate = new Date(__startDate);
      const endDate = new Date(__endDate);
      const now = new Date();
    
      return now >= startDate && now <= endDate;
    }
    if (!isWithinDateRange()) {
      //__pynLog('Invalid discount time!');
      return;
    }

    // Get product ID for the free item
    async function fetchProductId(productHandle) {
      try {
        const response = await fetch("/products/" + productHandle + "/products.json");
        if (!response.ok) throw new Error("Failed to fetch product data");

        const data = await response.json();
        return data.product.variants[0].id;
      } catch (error) {
        __pynLog("Error fetching product '" + productHandle + "': ", error);
        return [];
      }
    }

    async function getCollectionProductIds(collectionHandle) {
      try {
        const response = await fetch("/collections/" + collectionHandle + "/products.json");
        if (!response.ok) throw new Error("Failed to fetch collection data");
    
        const data = await response.json();
        return data.products.map(product => product.id);
      } catch (error) {
        __pynLog("Error fetching collection '" + collectionHandle + "': ", error);
        return [];
      }
    }
    
    async function saveSessionStorage() {
      // Function to get discount code from URL
      const path = window.location.href.toString();
      if (!path.includes("discount")) {
        return;
      }
      const urlParams = new URLSearchParams(window.location.search);
      
      // Extract discount code from path
      const discountCode = urlParams.get("discount") || "";
      if (discountCode == "") {
        sessionStorage.removeItem("wm_discount_code");
        sessionStorage.removeItem("wm_discount_user");
        sessionStorage.removeItem("wm_discount_excluded");
        sessionStorage.removeItem("wm_discount_free");
        return;
      }
      sessionStorage.setItem("wm_discount_code", discountCode);
  
      // Extract test_user if present
      const discountUser = urlParams.get("test") || "";
      sessionStorage.setItem("wm_discount_user", discountUser);
      
      const allExcludedProductIds = await Promise.all(__excludedCollections.map(getCollectionProductIds));
      sessionStorage.setItem("wm_discount_excluded", allExcludedProductIds.flat().join(','));

      const allFreeProductIds = await Promise.all(__freeProducts.map(fetchProductId));
      sessionStorage.setItem("wm_discount_free", allFreeProductIds.flat().join(','));
    }
    await saveSessionStorage();

    // Get saved discount code
    const discount_code = sessionStorage.getItem('wm_discount_code') || "";
    const discount_user = sessionStorage.getItem('wm_discount_user') || "";
    const discount_excluded = (sessionStorage.getItem('wm_discount_excluded') || "").split(',').map(Number);
    const discount_free = (sessionStorage.getItem('wm_discount_free') || "").split(',').map(Number);
    if (discount_code !== __discount_code) { //  || discount_user !== 'Pierre'
      return;
    }
    // Remove this when push live
    //__pynLog(discount_code);
    //__pynLog(discount_user);
    //__pynLog(discount_excluded);
    //__pynLog(discount_free);

    function checkProductAvailability() {
      const product_id = document.querySelector('[name="product-id"]');
      if (!product_id) {
        return false;
      }

      return !discount_excluded.includes(Number(product_id.value));
    }
    if (!checkProductAvailability()) {
      return;
    }
    //__pynLog("OK! product will be applied.");

    // Function to check and add free items
    try {
      const response = await fetch("/cart.js?discount=" + __discount_code);
      const cart = await response.json();
      
      discount_free.forEach(function(id) {
        if (!cart.items.some(item => item.id == id)) {
          __pynAppendForm(id);
        }
      });
    } catch (err) {
      __pynLog('Error fetching cart information: ' + err); 
    }
  });
})();

(function() {
  'use strict';

  // SVG Icons
  const heartIconFilled = `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>`;

  const heartIconOutline = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>`;

  const closeIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>`;

  const trashIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512"><path d="m62.205 150 26.569 320.735C90.678 493.865 110.38 512 133.598 512h244.805c23.218 0 42.92-18.135 44.824-41.265L449.795 150H62.205zm118.781 302c-7.852 0-14.458-6.108-14.956-14.063l-15-242c-.513-8.276 5.771-15.395 14.033-15.908 8.569-.601 15.381 5.757 15.908 14.033l15 242c.531 8.57-6.25 15.938-14.985 15.938zM271 437c0 8.291-6.709 15-15 15s-15-6.709-15-15V195c0-8.291 6.709-15 15-15s15 6.709 15 15v242zm89.97-241.062-15 242c-.493 7.874-7.056 14.436-15.908 14.033-8.262-.513-14.546-7.632-14.033-15.908l15-242c.513-8.276 7.764-14.297 15.908-14.033 8.262.513 14.546 7.632 14.033 15.908zM451 60h-90V45c0-24.814-20.186-45-45-45H196c-24.814 0-45 20.186-45 45v15H61c-16.569 0-30 13.431-30 30 0 16.567 13.431 30 30 30h390c16.569 0 30-13.433 30-30 0-16.569-13.431-30-30-30zm-120 0H181V45c0-8.276 6.724-15 15-15h120c8.276 0 15 6.724 15 15v15z" fill="currentColor"></path></svg>`;

  // Wishlist Manager
  const WishlistManager = {
    storageKey: 'shopify_wishlist',

    getWishlist: function() {
      try {
        const wishlist = localStorage.getItem(this.storageKey);
        return wishlist ? JSON.parse(wishlist) : [];
      } catch (e) {
        console.error('Error reading wishlist:', e);
        return [];
      }
    },

    saveWishlist: function(wishlist) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.updateWishlistCount();
        if (gtag) {
          gtag('event', 'wishlist_added');
        }
        return true;
      } catch (e) {
        console.error('Error saving wishlist:', e);
        return false;
      }
    },

    addItem: function(product) {
      const wishlist = this.getWishlist();
      const exists = wishlist.find(item => item.id === product.id);
      
      if (!exists) {
        wishlist.push(product);
        this.saveWishlist(wishlist);
        return true;
      }
      return false;
    },

    removeItem: function(productId) {
      let wishlist = this.getWishlist();
      wishlist = wishlist.filter(item => item.id !== productId);
      this.saveWishlist(wishlist);
      return true;
    },

    toggleItem: function(product) {
      const wishlist = this.getWishlist();
      const exists = wishlist.find(item => item.id === product.id);
      
      if (exists) {
        this.removeItem(product.id);
        return false;
      } else {
        this.addItem(product);
        return true;
      }
    },

    isInWishlist: function(productId) {
      const wishlist = this.getWishlist();
      return wishlist.some(item => item.id === productId);
    },

    updateWishlistCount: function() {
      const wishlist = this.getWishlist();
      const count = wishlist.length;
      const countBadge = document.querySelector('.wishlist-float-btn .wishlist-count');
      
      if (countBadge) {
        countBadge.textContent = count;
        countBadge.style.display = count > 0 ? 'flex' : 'none';
      }
    }
  };

  // UI Manager
  const UIManager = {
    init: function() {
      this.createFloatingButton();
      this.createWishlistPanel();
      this.attachProductPageButtons();
      WishlistManager.updateWishlistCount();
    },

    createFloatingButton: function() {
      const button = document.createElement('button');
      button.className = 'wishlist-float-btn';
      button.innerHTML = `
        ${heartIconFilled}
        <span class="wishlist-count">0</span>
        <span>Wishlist</span>
      `;
      button.addEventListener('click', () => this.togglePanel());
      document.body.appendChild(button);
    },

    createWishlistPanel: function() {
      const panel = document.createElement('div');
      panel.className = 'wishlist-panel';
      panel.innerHTML = `
        <div class="wishlist-panel-header">
          <h3>My Wishlist</h3>
          <button class="wishlist-close-btn">${closeIcon}</button>
        </div>
        <div class="wishlist-panel-content">
          <div class="wishlist-items"></div>
        </div>
      `;
      
      document.body.appendChild(panel);
      
      const closeBtn = panel.querySelector('.wishlist-close-btn');
      closeBtn.addEventListener('click', () => this.closePanel());
      
      panel.addEventListener('click', (e) => {
        if (e.target === panel) {
          this.closePanel();
        }
      });

      this.renderWishlistItems();
    },

    togglePanel: function() {
      const panel = document.querySelector('.wishlist-panel');
      const isOpen = panel.classList.contains('open');
      
      if (isOpen) {
        this.closePanel();
      } else {
        this.openPanel();
      }
    },

    openPanel: function() {
      const panel = document.querySelector('.wishlist-panel');
      panel.classList.add('open');
      document.body.style.overflow = 'hidden';
      this.renderWishlistItems();
    },

    closePanel: function() {
      const panel = document.querySelector('.wishlist-panel');
      panel.classList.remove('open');
      document.body.style.overflow = '';
    },

    renderWishlistItems: function() {
      const container = document.querySelector('.wishlist-items');
      const wishlist = WishlistManager.getWishlist();
      
      if (wishlist.length === 0) {
        container.innerHTML = `
          <div class="wishlist-empty">
            <div class="wishlist-empty-icon">${heartIconOutline}</div>
            <p>Your wishlist is empty</p>
            <span>Add items you love to save them for later</span>
          </div>
        `;
        return;
      }

      container.innerHTML = wishlist.map(item => `
        <div class="wishlist-item" data-product-id="${item.id}">
          <div class="wishlist-item-image">
            <img src="${item.image}" alt="${item.title}" />
          </div>
          <div class="wishlist-item-details">
            <h4>${item.title}</h4>
            <p class="wishlist-item-price">${item.price}</p>
            <a href="${item.url}" class="wishlist-item-view-btn">View Product</a>
          </div>
          <button class="wishlist-item-remove-btn" data-product-id="${item.id}">
            ${trashIcon}
          </button>
        </div>
      `).join('');

      // Attach remove handlers
      const removeButtons = container.querySelectorAll('.wishlist-item-remove-btn');
      removeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const productId = Number(e.currentTarget.getAttribute('data-product-id'));
          this.removeFromWishlist(productId);
        });
      });
    },

    attachProductPageButtons: function() {
      // Look for product forms on the page
      const productForms = document.querySelectorAll('form[action*="/cart/add"]');
      if (productForms.length != 2) {
        return;
      }
      const productData = this.extractProductData(productForms[0]);
      if (productData) {
        this.createProductPageButton(productForms[0], productData);
      }
    },

    extractProductData: function(form) {
      try {
        // Try to get product data from meta tags or global variables
        const product = window.productJSON;
        if (!product) return null;

        return {
          id: product.id,
          title: document.title,
          price: product.price ? `$${(product.price / 100).toFixed(2)}` : 'Price not available',
          image: product.featured_image,
          url: '/products/' + product.handle
        };
      } catch (e) {
        console.error('Error extracting product data:', e);
        return null;
      }
    },

    getProductImage: function() {
      const imgSelectors = [
        '.product-image img',
        '.product__image img',
        '.product-gallery img',
        '.product-single__photo img',
        'img[src*="products"]'
      ];

      for (let selector of imgSelectors) {
        const img = document.querySelector(selector);
        if (img) {
          return img.src;
        }
      }

      return 'https://via.placeholder.com/300';
    },

    updateWishlistToggleButton: function(active) {
      return active ? heartIconFilled + ' <span>Remove from Wishlist</span>' : heartIconOutline + ' <span>Add to Wishlist</span>';
    },

    createProductPageButton: function(form, productData) {
      const productDescription = document.querySelector('.product__description');
      if (!productDescription) {
        console.warn('Product description not found, wishlist button not added');
        return;
      }
      
      const wishlistBtn = document.createElement('button');
      wishlistBtn.type = 'button';
      wishlistBtn.className = 'wishlist-product-btn';
      
      const isInWishlist = WishlistManager.isInWishlist(productData.id);
      wishlistBtn.classList.toggle('active', isInWishlist);
      wishlistBtn.innerHTML = this.updateWishlistToggleButton(isInWishlist);
      wishlistBtn.setAttribute('data-product-id', productData.id);
      
      wishlistBtn.addEventListener('click', () => {
        const isAdded = WishlistManager.toggleItem(productData);
        wishlistBtn.classList.toggle('active', isAdded);
        wishlistBtn.innerHTML = this.updateWishlistToggleButton(isAdded);
        
        // Show feedback
        this.showNotification(isAdded ? 'Added to wishlist' : 'Removed from wishlist');
      });

      productDescription.parentNode.insertBefore(wishlistBtn, productDescription);
    },

    removeFromWishlist: function(productId) {
      WishlistManager.removeItem(productId);
      this.renderWishlistItems();
      
      // Update product page button if on product page
      const productBtn = document.querySelector(`.wishlist-product-btn[data-product-id="${productId}"]`);
      if (productBtn) {
        productBtn.classList.remove('active');
        productBtn.innerHTML = this.updateWishlistToggleButton(false);
      }

      this.showNotification('Removed from wishlist');
    },

    showNotification: function(message) {
      const notification = document.createElement('div');
      notification.className = 'wishlist-notification';
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(() => {
        notification.classList.add('show');
      }, 10);

      setTimeout(() => {
        notification.classList.remove('show');
        setTimeout(() => {
          notification.remove();
        }, 300);
      }, 2000);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => UIManager.init());
  } else {
    UIManager.init();
  }

})();